import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {isEmpty} from 'lodash';

const PrivateRoute = ({component: Component, ...rest}) => {

    const user = sessionStorage.getItem('Token');

    return (
        <Route
            {...rest}
            render={props =>
                !isEmpty(user) ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: '/users',
                            state: {from: props.location}
                        }}
                    />
                )
            }
        />
    );
};

export default PrivateRoute;
